import { Component } from '@angular/core';
import { ApplyButtonComponent } from '../../../shared/components/apply-button/apply-button.component';

@Component({
  selector: 'app-doubt-section',
  standalone: true,
  imports: [ApplyButtonComponent],
  templateUrl: './doubt-section.component.html',
  styleUrls: ['./doubt-section.component.scss']
})
export class DoubtSectionComponent {} 